import type { ComponentSearchViewState } from './types';

type ViewpointFiltersEmptyStateInput = Pick<
  ComponentSearchViewState,
  'componentName' | 'startSetFilter' | 'selectedComponentTypeHasNoInstances'
>;

/**
 * The "No components match this Viewpoint's filters" empty state must only claim
 * the filters are the cause when the viewpoint actually has a start-set filter
 * (`startSetFilter !== null`) and the user has not narrowed the results with
 * their own search term (`!componentName`). Without the filter check a viewpoint
 * whose start type is simply empty would wrongly blame its (absent) filters.
 */
export const hasNoComponentsMatchingViewpointFilters = ({
  componentName,
  startSetFilter,
  selectedComponentTypeHasNoInstances,
}: ViewpointFiltersEmptyStateInput): boolean =>
  !componentName &&
  startSetFilter !== null &&
  selectedComponentTypeHasNoInstances;
